import React from 'react'
import { MentorCard } from "./MentorCard"
import MemberPng from "../images/member.png"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import "swiper/css";
import './MentorsSection.css';


export const MentorsSection = () => {
  return (
    <>
      <div className="flex flex-col gap-5 py-10">
        <h2 className="text-4xl">Meet our <span className="text-CSec">Mentors</span></h2>
      </div>
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        modules={[Pagination, Navigation]}
        navigation
        pagination={{ clickable: true }}
        // // onSlideChange={() => console.log('slide change')}
        // // onSwiper={(swiper) => console.log(swiper)}

        breakpoints={{
          340: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          }, 
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}

      >

        <SwiperSlide className="carr">
          <MentorCard
            name={"Rakesh Singh"}
            desc="Lorem ipsum dolor sit amet, lectus magna fringilla urna, porttitor rhoncus dolor"
            role="Sales Manager"
            img={MemberPng}
            social={{ fb: "#", insta: "#", tw: "#" }}
          /></SwiperSlide>
        <SwiperSlide>
          <MentorCard
            name={"Rakesh Singh"}
            desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor"
            role="Sales Manager"
            img={MemberPng}
            social={{ fb: "#", insta: "#", tw: "#" }}
          /></SwiperSlide>
        <SwiperSlide className="carr">
          <MentorCard
            name={"Rakesh Singh"}
            desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor"
            role="Sales Manager"
            img={MemberPng}
            social={{ fb: "#", insta: "#", tw: "#" }}
          /></SwiperSlide>
        <SwiperSlide className="carr">     <MentorCard
          name={"Rakesh Singh"}
          desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor"
          role="Sales Manager"
          img={MemberPng}
          social={{ fb: "#", insta: "#", tw: "#" }}
        /></SwiperSlide>

      </Swiper>
    </>


  )
}
